"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPrivateGraphAPIEnabled = exports.isAutogeneratedTrailerEnabled = void 0;
var tslib_1 = require("tslib");
var experiments_1 = require("./utils/experiments");
Object.defineProperty(exports, "isAutogeneratedTrailerEnabled", { enumerable: true, get: function () { return experiments_1.isAutogeneratedTrailerEnabled; } });
Object.defineProperty(exports, "isPrivateGraphAPIEnabled", { enumerable: true, get: function () { return experiments_1.isPrivateGraphAPIEnabled; } });
tslib_1.__exportStar(require("./utils/get-url-to-channel"), exports);
//# sourceMappingURL=index.js.map